import * as React from 'react';
import cx from 'classnames';
import StringWidget from 'components/StringWidget';
import StarIcon from 'images/rating-star.svg';
import styles from './StarsWidget.css';
export default function StarsWidget(props) {
    const { stars, className, newSeller, showStars, starImgClass } = props;
    // Keeping green as default background color. Change to other colors based on logic
    const classes = cx(styles['stars'], {
        [styles['red']]: stars < 2,
        [styles['yellow']]: stars >= 2 && stars < 3,
        [styles['bar-color-6']]: newSeller
    }, className);
    if (!stars && !newSeller) {
        return null;
    }
    return (<div className={classes}>
			{newSeller ? <StringWidget strKey="newSellerText"/> : stars}
			{showStars ? <img src={StarIcon} className={cx(styles['star-img'], starImgClass)}/> : null}
		</div>);
}
